var render = function render(){var _vm=this,_c=_vm._self._c;return _c('field-facility-complex-list',{attrs:{"breadcrumb":[{ title: 'Home' }, { title: '중대시민재해 대상시설 현황' }, { title: '공중이용시설' }, { title: '의료기관', active: true }],"field-code":_vm.fieldCode,"columns":_vm.columns,"table-list":_vm.tableList},on:{"update-field-list":_vm.updateFieldList}})
}
var staticRenderFns = []

export { render, staticRenderFns }